import LocalStorageService from './LocalStorageService';

const hasPermission = (permission: string) => {
  return LocalStorageService.getUserPermissions().includes(permission);
};

const hasAccess = (permissions: string[]) => {
  return permissions.includes('admin:manage');
};

const isAuthenticated = () => {
  const permissions = LocalStorageService.getUserPermissions();
  return permissions.includes('admin:manage');
};

const isAdmin = () => {
  return hasPermission('admin:manage');
};

export default {
  isAdmin,
  isAuthenticated,
  hasPermission,
  hasAccess
};
